import React from 'react'

/**
 * Hook that returns the boolean value when the sticky element Stuck/Unstuck
 * observeTargetId - id of static element above the sticky element
 */

export const useStickyObserver = (observeTargetId: string) => {
  const [isStuck, setIsStuck] = React.useState(false)

  React.useEffect(() => {
    const stickyObserver = new IntersectionObserver((records) => {
      if (!records[0].isIntersecting !== isStuck) {
        setIsStuck(!records[0].isIntersecting)
      }
    })
    const observeTarget = document.getElementById(observeTargetId)
    if (observeTarget) {
      stickyObserver.observe(observeTarget)
    }
  }, [isStuck])

  return isStuck
}

export const useDetectSticky = (
  observeTargetId: string,
  stickyTopValue: number = 0,
  referenceIdForScrollingBlock?: string
) => {
  const [isStuck, setIsStuck] = React.useState(false)

  React.useEffect(() => {
    const scrollHandler = () => {
      const element = typeof document !== 'undefined' ? document.getElementById(observeTargetId) : null
      if (element) {
        setIsStuck(
          element.getBoundingClientRect().top <= stickyTopValue &&
            element.getBoundingClientRect().bottom >= stickyTopValue
        )
      } else {
        setIsStuck(false)
      }
    }

    const ref = referenceIdForScrollingBlock ? document.getElementById(referenceIdForScrollingBlock) : null
    if (ref) {
      ref.addEventListener('scroll', scrollHandler)
    } else {
      document.addEventListener('scroll', scrollHandler)
    }

    return () => {
      if (ref) {
        ref.removeEventListener('scroll', scrollHandler)
      } else {
        document.removeEventListener('scroll', scrollHandler)
      }
    }
  }, [observeTargetId, stickyTopValue])

  return isStuck
}
